import Button from '../../../components/base/Button';

export default function BecomePartner() {
  const handleContactClick = () => {
    window.open('tel:+21620403150', '_self');
  };

  return (
    <section className="py-20 bg-red-600">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Devenez Notre <span className="text-red-200">Partenaire</span>
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Vous êtes fabricant ou distributeur de solutions de sécurité ? 
            Rejoignez notre réseau de partenaires privilégiés.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-handshake-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Partenariat Gagnant</h3>
              <p className="text-red-100">Développons ensemble de nouveaux marchés</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Réseau National</h3>
              <p className="text-red-100">Accédez à notre réseau de clients</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Croissance Mutuelle</h3>
              <p className="text-red-100">Grandissons ensemble sur le marché</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              className="bg-red-600 text-white px-8 py-3 rounded-xl font-medium hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
              onClick={handleContactClick}
            >
              <i className="ri-phone-line mr-2"></i>
              Contactez-nous
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
